export default __webpack_public_path__ + "static/media/logo_sm.43ad6934.svg";